import MapView from "@/views/MapView";
import MapPreviewView from "@/views/MapPreviewView.vue";
import DataView from "@/views/DataView";
import DataVehiclesView from "@/views/data/VehiclesView";
import DataPersonsView from "@/views/data/PersonsView";
import DataSpecialAccessesView from "@/views/data/SpecialAccessesView";
import DataGroupSetsView from "@/views/data/GroupSetsView";
import DataSharingsView from "@/views/data/SharingsView";
import DataContractsView from "@/views/data/ContractsView";
import DataSubjectsView from "@/views/data/SubjectsView";
import DataCompaniesView from "@/views/data/CompaniesView";
import DataDeviceConnectionsView from "@/views/data/DeviceConnectionsView";
import DataApiConnectionsView from "@/views/data/ApiConnectionsView";
import DataVehicleView from "@/views/data/VehicleView";
import DataPersonView from "@/views/data/PersonView";
import DataSpecialAccessView from "@/views/data/SpecialAccessView";
import DataGroupSetView from "@/views/data/GroupSetView";
import DataSharingView from "@/views/data/SharingView";
import DataContractView from "@/views/data/ContractView";
import DataSubjectView from "@/views/data/SubjectView";
import DataCompanyView from "@/views/data/CompanyView";
import ReportView from "@/views/ReportView";
import PlanView from "@/views/PlanView";
import LogbookReport from "@/views/report/LogbookReport";
import PerformanceReport from "@/views/report/PerformanceReport";
import MachinePerformanceReport from "@/views/report/MachinePerformanceReport";
import DriverPerformanceReport from "@/views/report/DriverPerformanceReport";
import TemperatureReport from "@/views/report/TemperatureReport.vue";
import TanksReport from "@/views/report/TanksReport";
import TachographReport from "@/views/report/TachographReport";
import TravelExpensesReport from "@/views/report/TravelExpensesReport";
import VehiclesSummaryReport from "@/views/report/VehiclesSummaryReport";
import CountriesSummaryReport from "@/views/report/CountriesSummaryReport";
import AbroadSummaryReport from "@/views/report/AbroadSummaryReport";
import PlannedServicesReport from "@/views/report/PlannedServicesReport.vue";
import RefuelingsReport from "@/views/report/RefuelingsReport.vue";
import CompaniesSummaryReport from "@/views/report/CompaniesSummaryReport";
import NotFound from "@/views/NotFound";

/**
 * Oprávnění lze definovat v meta dvěma způsoby:
 * 1. modulea a access (write,delete, read - implicitně)
 * 2. Pomocí role - superuser, admin, dispatcher
 */

export default [
  {
    path: "/",
    name: "root",
    redirect: "/map"
  },
  {
    path: "/map",
    name: "automap",
    component: MapView
  },
  {
    path: "/:ccode/map",
    name: "map",
    component: MapView
  },
  {
    path: "/:ccode/map-preview",
    name: "map-preview",
    component: MapPreviewView
  },
  {
    name: "map/vehicle",
    path: "/:ccode/map/vehicle/:id",
    component: MapView
  },
  {
    name: "map/logbook",
    path: "/:ccode/map/vehicle/:id/logbook",
    component: MapView
  },
  {
    name: "map/refueling",
    path: "/:ccode/map/vehicle/:id/refueling",
    component: MapView
  },
  {
    name: "map/events",
    path: "/:ccode/map/vehicle/:id/events",
    component: MapView
  },
  {
    name: "map/contracts",
    path: "/:ccode/map/vehicle/:id/contracts",
    component: MapView
  },
  {
    name: "map/service",
    path: "/:ccode/map/vehicle/:id/service",
    component: MapView
  },
  {
    name: "map/history",
    path: "/:ccode/map/vehicle/:id/history",
    component: MapView
  },
  {
    path: "/:ccode/data",
    name: "data",
    component: DataView,
    children: [
      {
        name: "data/vehicles",
        path: "vehicles",
        component: DataVehiclesView,
        meta: {
          conditional: true,
          module: "vehicle",
          access: "read"
        }
      },
      {
        name: "data/persons",
        path: "persons",
        component: DataPersonsView,
        meta: {
          conditional: true,
          module: "person",
          access: "read"
        }
      },
      {
        name: "data/special-accesses",
        path: "special-accesses",
        component: DataSpecialAccessesView,
        meta: {
          conditional: true,
          module: "special-access",
          access: "read"
        }
      },
      {
        name: "data/groupsets",
        path: "groupsets",
        component: DataGroupSetsView,
        meta: {
          conditional: true,
          module: "groupset",
          access: "read"
        }
      },
      {
        name: "data/sharings",
        path: "sharings",
        component: DataSharingsView,
        meta: {
          conditional: true,
          module: "sharing",
          access: "read"
        }
      },
      {
        name: "data/contracts",
        path: "contracts",
        component: DataContractsView,
        meta: {
          conditional: true,
          module: "contract",
          access: "read"
        }
      },
      {
        name: "data/subjects",
        path: "subjects",
        component: DataSubjectsView,
        meta: {
          conditional: true,
          module: "subject",
          access: "read"
        }
      },
      {
        name: "data/companies",
        path: "companies",
        component: DataCompaniesView,
        meta: {
          conditional: true,
          module: "company",
          access: "read"
        }
      },
      {
        name: "data/device-connections",
        path: "device-connections",
        component: DataDeviceConnectionsView,
        meta: {
          conditional: true,
          module: "device-connection",
          access: "read"
        }
      },
      {
        name: "data/api-connections",
        path: "api-connections",
        component: DataApiConnectionsView,
        meta: {
          conditional: true,
          module: "api-connection",
          access: "read"
        }
      },
      {
        name: "data/vehicle",
        path: "vehicle/:id",
        component: DataVehicleView,
        meta: {
          conditional: true,
          module: "vehicle",
          access: "write"
        }
      },
      {
        name: "data/person",
        path: "person/:id",
        component: DataPersonView,
        meta: {
          conditional: true,
          module: "person",
          access: "read"
        }
      },
      {
        name: "data/special-access",
        path: "special-access/:id",
        component: DataSpecialAccessView,
        meta: {
          conditional: true,
          module: "special-access",
          access: "read"
        }
      },
      {
        name: "data/groupset",
        path: "groupset/:id",
        component: DataGroupSetView,
        meta: {
          conditional: true,
          module: "groupset",
          access: "read"
        }
      },
      {
        name: "data/sharing",
        path: "sharing/:id",
        component: DataSharingView,
        meta: {
          conditional: true,
          module: "sharing",
          access: "read"
        }
      },
      {
        name: "data/contract",
        path: "contract/:id",
        component: DataContractView,
        meta: {
          conditional: true,
          module: "contract",
          access: "read"
        }
      },
      {
        name: "data/subject",
        path: "subject/:id",
        component: DataSubjectView,
        meta: {
          conditional: true,
          module: "subject",
          access: "read"
        }
      },
      {
        name: "data/company",
        path: "company/:id",
        component: DataCompanyView,
        meta: {
          conditional: true,
          module: "company",
          access: "read"
        }
      }
    ]
  },
  {
    path: "/:ccode/plan",
    name: "plan",
    component: PlanView,
    meta: {
      conditional: true,
      module: "contract",
      access: "read"
    }
  },
  {
    path: "/:ccode/report",
    name: "report",
    component: ReportView,
    children: [
      {
        path: "logbook",
        name: "report/logbook",
        component: LogbookReport
      },
      {
        path: "performance",
        name: "report/performance",
        component: PerformanceReport
      },
      {
        path: "machine-performance",
        name: "report/machine-performance",
        component: MachinePerformanceReport
      },
      {
        path: "driver-performance",
        name: "report/driver-performance",
        component: DriverPerformanceReport
      },
      {
        path: "temperature",
        name: "report/temperature",
        component: TemperatureReport
      },
      {
        path: "tanks",
        name: "report/tanks",
        component: TanksReport
      },
      {
        path: "tachograph",
        name: "report/tachograph",
        component: TachographReport
      },
      {
        path: "travel-expenses",
        name: "report/travel-expenses",
        component: TravelExpensesReport
      },
      {
        path: "vehicles-summary",
        name: "report/vehicles-summary",
        component: VehiclesSummaryReport
      },
      {
        path: "countries-summary",
        name: "report/countries-summary",
        component: CountriesSummaryReport
      },
      {
        path: "abroad-summary",
        name: "report/abroad-summary",
        component: AbroadSummaryReport
      },
      {
        path: "refuelings",
        name: "report/refuelings",
        component: RefuelingsReport
      },
      {
        path: "planned-services",
        name: "report/planned-services",
        component: PlannedServicesReport
      },
      {
        path: "companies-summary",
        name: "report/companies-summary",
        component: CompaniesSummaryReport,
        meta: {
          conditional: true,
          permission: "superuser"
        }
      }
    ]
  },
  // Tohle musi byt vzdy posledni - je to fallback pro pripad, ze cesta nesedi do zadne predchozi
  {
    path: "*",
    component: NotFound
  }
];
